import { Stack, Typography } from '@mui/material';

import { gql } from '@graphql/__generated__';
import type { DateTooltipContentFragment } from '@graphql/__generated__/graphql';
import { formatFullDate } from '@modules/_shared/components/feed-v2/utils/formatters';
import { useLocale } from '@shared/hooks/locale';

export const DATE_TOOLTIP_CONTENT_FRAGMENT = gql(/* GraphQL */ `
  fragment DateTooltipContent on activities {
    id
    activity_type
    created_at
    done
    consolidated_done_at
    due_at
    start_date
  }
`);

type Props = {
  activity: DateTooltipContentFragment;
};

export const DateTooltipContent = ({ activity }: Props) => {
  const { t, locale } = useLocale();
  const isNote = activity.activity_type === 'note';
  const doneAt = activity.done ? activity.consolidated_done_at : null;
  const dueDate = activity.due_at ?? activity.start_date;
  const createdSameAsDone =
    !isNote &&
    activity.created_at != null &&
    doneAt != null &&
    formatFullDate(locale, activity.created_at) ===
      formatFullDate(locale, doneAt);

  return (
    <Stack spacing={0.25}>
      {!createdSameAsDone && activity.created_at != null && (
        <Typography
          variant="caption"
          sx={{ display: 'block', lineHeight: 1.4 }}
        >
          <strong>{t('Created on')}:</strong>{' '}
          {formatFullDate(locale, activity.created_at)}
        </Typography>
      )}
      {!isNote && dueDate != null && (
        <Typography
          variant="caption"
          sx={{ display: 'block', lineHeight: 1.4 }}
        >
          <strong>{t('Due on')}:</strong> {formatFullDate(locale, dueDate)}
        </Typography>
      )}
      {!isNote && doneAt != null && (
        <Typography
          variant="caption"
          sx={{ display: 'block', lineHeight: 1.4 }}
        >
          <strong>{t('Completed on')}:</strong> {formatFullDate(locale, doneAt)}
        </Typography>
      )}
    </Stack>
  );
};
